// src/components/Admin/CommentManager/CreateCommentPointSetting.jsx
import { useEffect, useState } from 'react';
import { Box, TextField, Button, Stack } from '@mui/material';
import api from '../../../api/axios';

export default function CreateCommentPointSetting() {
    const ACTION = 'create_comment';
    const [policy, setPolicy] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api
            .get(`/api/point-policy/?action=${ACTION}`)
            .then(res => setPolicy(res.data[0] ?? null))
            .catch(() => alert('댓글 작성 포인트 정책을 불러오지 못했습니다.'))
            .finally(() => setLoading(false));
    }, []);

    const handleSave = () => {
        if (!policy) return;
        const payload = { action: ACTION, amount: policy.amount };

        const req = policy.id
            ? api.put(`/api/point-policy/${policy.id}/`, payload)
            : api.post('/api/point-policy/', payload);

        req.then(({ data }) => {
            setPolicy(data);
            alert('댓글 작성 Leaf🌿가 저장되었습니다.');
        })
            .catch(() => alert('저장 실패'));
    };

    if (loading) return null;

    return (
        <Box sx={{ p: 2 }}>
            <Stack direction="row" spacing={2} sx={{ mt: 2, alignItems: 'center' }}>
                <TextField
                    label="지급 Leaf🌿"
                    type="number"
                    value={policy?.amount ?? 0}
                    onChange={e =>
                        setPolicy(prev => ({ ...prev, amount: Number(e.target.value) }))
                    }
                    inputProps={{ min: 0 }}
                    sx={{ width: 120 }}
                />
                <Button variant="contained" onClick={handleSave}>저장</Button>
            </Stack>
        </Box>
    );
}
